module.exports = __webpack_public_path__ + "static/media/1_r_cam_8.7_55.c0a5a635.png";